export default __webpack_public_path__ + "static/media/63-MarioCyr.62f5a3a5.jpg";